<template>
    <div dusk="ReaderPromoteApp" class="max-w-sm rounded bg-theme-bg text-theme-text">
        <div class="mx-4 flex flex-wrap py-3">
            <div class="w-full px-4">
                <div class="relative mt-5 flex w-full items-center justify-center">
                    <img :src="mockupImage" class="mb-4 h-52 w-auto" alt="Mockup móvil" />

                    <img
                        :src="publication.cover"
                        class="absolute left-1/2 top-1/2 h-[170px] w-40 -translate-x-1/2 -translate-y-[44%] object-fill"
                    />
                </div>
            </div>
            <div class="my-5 w-full px-4 pt-1">
                <div class="relative">
                    <div class="w-full px-4">
                        <div>
                            <h2 class="text-xl font-medium text-blue-500 dark:text-purple-400">
                                {{ localizations[lang].promoteApp.title_first_part }}
                                {{ promoteApp.appName }}
                                {{ localizations[lang].promoteApp.title_second_part }}
                            </h2>
                            <h3 class="mt-3 text-left text-theme-text">
                                {{ localizations[lang].promoteApp.text }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full justify-center px-4 pt-0 text-center">
                <ul class="promote-app-badges flex w-full list-none justify-evenly space-x-4">
                    <li v-if="!isAndroid">
                        <a :href="promoteApp.appleAppLink">
                            <img :alt="localizations[lang].promoteApp.downloadAppStore" :src="badges.apple" />
                        </a>
                    </li>

                    <li v-if="!isApple">
                        <a :href="promoteApp.androidAppLink">
                            <img :alt="localizations[lang].promoteApp.downloadPlayStore" :src="badges.android" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['publication', 'localizations', 'lang', 'promoteApp']),
        ...mapGetters(['isEpub', 'isAudiobook', 'isAndroid', 'isApple', 'isAudiobook']),
        mockupImage() {
            return `${process.env.VITE_URL}/volpe-assets/images/mockup-movil.webp`;
        },
        badges() {
            return {
                android: `${process.env.VITE_URL}/volpe-assets/images/stores-badges/google-play-badge_${this.lang}.png`,
                apple: `${process.env.VITE_URL}/volpe-assets/images/stores-badges/apple-store-badge_${this.lang}.png`,
            };
        },
    },
};
</script>

<style scoped>
.promote-app-badges li img {
    height: clamp(38px, 2.5vw, 40px);
}

@keyframes opacityFade {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
